import { persistInternalSubtaskTemplateFromDraft } from './changePersistInternalSubtaskTemplate';
import type { ReviewQuestionDraft } from './changeInstanceChecklistFields';

export async function savePersonalInternalSubtaskTemplate(opts: {
  name: string;
  groupId: number;
  questions: ReviewQuestionDraft[];
  templateId?: number | null;
}): Promise<number> {
  return persistInternalSubtaskTemplateFromDraft({
    ...opts,
    mode: 'personal',
  });
}
